export default __webpack_public_path__ + "static/media/edit.ed901b63.svg";